import { Link } from "react-router-dom";
import { LogoMark } from "@/components/site/Logo";

export default function PaymentCancel() {
  return (
    <main className="flex min-h-screen items-center justify-center px-5" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg rounded-[2rem] border border-fg/10 bg-[var(--ink-2)] p-10 text-center">
        <LogoMark className="mx-auto h-12 w-12" />
        <h1 className="mt-6 font-display text-4xl">Pagamento annullato</h1>
        <p className="mt-3 text-fg2">Nessun addebito effettuato. I prodotti sono ancora nel tuo carrello.</p>
        <Link to="/" data-testid="payment-cancel-back" className="mt-8 inline-block rounded-full bg-[var(--paper)] px-7 py-3 font-semibold text-[var(--ink)]">Torna al negozio</Link>
      </div>
    </main>
  );
}
